export default "__VITE_ASSET__q$8U642j__"